import * as React from "react";
import { teileDateiname } from "./DateinameKasten";

/**
 * T-397: Name des PDFs eines DVAG-Kontakthistorie-Eintrags, das beim Zuordnen zu
 * einem Vorgang als Dokument angelegt wird. Das PDF ist dann noch kein Dokument —
 * das Feld sammelt nur den gewünschten Namen, den der Aufrufer weiterreicht.
 *
 * Bearbeitet wird nur der Teil vor der Endung (wie in `DateinameKasten`); Optik
 * der `vgd`-Fenster (Anlage-Fenster, Vorgangs-Auswahl).
 */

/**
 * Neuer Name inkl. Endung — nur, wenn er sich vom Original unterscheidet.
 * Ein leeres Feld lässt das Original stehen (`undefined`).
 */
export function geaenderterDokumentName(original: string, stamm: string): string | undefined {
    const { stamm: alt, endung } = teileDateiname(original);
    const neu = stamm.replace(/\s+/g, " ").trim();
    return neu && neu !== alt ? `${neu}${endung}` : undefined;
}

export const DokumentNameFeld: React.FC<{
    /** Name des Originals inkl. Endung. */
    original: string;
    /** Aktueller Namensteil vor der Endung. */
    stamm: string;
    onStamm: (stamm: string) => void;
}> = ({ original, stamm, onStamm }) => {
    const { stamm: alt, endung } = teileDateiname(original);
    return (
        <div>
            <div style={{ color: "var(--vgd-ink-3)", fontSize: "0.75rem", fontWeight: 700, marginBottom: 4 }}>
                Aus der Kontakthistorie
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: "0.85rem" }}>
                <input
                    className="vgd-input"
                    style={{ flex: "1 1 auto", minWidth: 0, padding: "5px 9px", fontSize: "0.82rem" }}
                    value={stamm}
                    onChange={(e) => onStamm(e.target.value)}
                    placeholder={alt}
                    aria-label="Dateiname des Dokuments aus der Kontakthistorie"
                />
                {endung && (
                    <span style={{ flex: "0 0 auto", color: "var(--vgd-ink-3)", fontWeight: 600 }}>{endung}</span>
                )}
            </div>
        </div>
    );
};
